import React from 'react'

const Warehouse = () => {
  return (
    <div class='ware-div'>
        <div class='ware-div1'>
            <h1 class='ware-h'>WareHouse Fire Pumps</h1>
        </div>
        <div class='container'>
            <h1 class='ware-h1'>Powering protection when it matters most—our warehouse fire pumps ensure instant, reliable response to every emergency</h1>
            <h2 class='ware-h2'>Our WareHouse Fire Pump Works</h2>
            <div class='row'>
                <div class='col-12 col-sm-12 col-md-6 col-lg-3 mt-4'>
                    <img src='./Images/ware1.jpg' alt='' height={250} class='ware-img' />
                </div>
                <div class='col-12 col-sm-12 col-md-6 col-lg-3 mt-4'>
                    <img src='./Images/ware2.jpg' alt='' height={250} class='ware-img' />
                </div>
                <div class='col-12 col-sm-12 col-md-6 col-lg-3 mt-4'>
                    <img src='./Images/ware3.png' alt='' height={250} class='ware-img' />
                </div>
                <div class='col-12 col-sm-12 col-md-6 col-lg-3 mt-4'>
                    <img src='./Images/ware4.jpg' alt='' height={250} class='ware-img' />
                </div>
            </div>
            <div class='row'>
                <div class='col-12 col-sm-12 col-md-6 col-lg-3 mt-4'>
                    <img src='./Images/ware1.jpg' alt='' height={250} class='ware-img' />
                </div>
                <div class='col-12 col-sm-12 col-md-6 col-lg-3 mt-4'>
                    <img src='./Images/ware2.jpg' alt='' height={250} class='ware-img' />
                </div>
                <div class='col-12 col-sm-12 col-md-6 col-lg-3 mt-4'>
                    <img src='./Images/ware3.png' alt='' height={250} class='ware-img' />
                </div>
                <div class='col-12 col-sm-12 col-md-6 col-lg-3 mt-4'>
                    <img src='./Images/ware4.jpg' alt='' height={250} class='ware-img' />
                </div>
            </div>
            <div class='row'>
                <div class='col-12 col-sm-12 col-md-6 col-lg-3 mt-4'>
                    <img src='./Images/ware1.jpg' alt='' height={250} class='ware-img' />
                </div>
                <div class='col-12 col-sm-12 col-md-6 col-lg-3 mt-4'>
                    <img src='./Images/ware2.jpg' alt='' height={250} class='ware-img' />
                </div>
                <div class='col-12 col-sm-12 col-md-6 col-lg-3 mt-4'>
                    <img src='./Images/ware3.png' alt='' height={250} class='ware-img' />
                </div>
                <div class='col-12 col-sm-12 col-md-6 col-lg-3 mt-4'>
                    <img src='./Images/ware4.jpg' alt='' height={250} class='ware-img' />
                </div>
            </div>
            
        </div>
    </div>
  )
}

export default Warehouse